// extracted by mini-css-extract-plugin
export default {"title":"graph_title__XVM-l","graphHeader":"graph_graphHeader__m7wxH","loaderWrapper":"graph_loaderWrapper__hpRSH"};